module.exports = __webpack_public_path__ + "img/img22.8b0703df.jpg";